export const inputNumberValidator = (rule: any, value: any, callback: any) => {
  if (!parseInt(value) || parseInt(value) < 1) {
    throw new Error();
  }
  return Promise.resolve();
};

export const isNumeric = (value: string) => {
  return /^-?\d+$/.test(value);
};

export function validateOnlyNumber(t: string): string {
  const inputValue = t;
  const convertedNumber = inputValue.replace(/^[^\d].[^\d]/g, "");
  return convertedNumber;
}

export function validateOnlyNumWDecimal(t: string): string {
  const inputValue = t;
  const convertedNumber = inputValue.replace(/^0+|[^0-9.]/g, "");
  return convertedNumber;
}
export const handleNumberOnlyCopyPaste = (e: React.KeyboardEvent<HTMLInputElement>) => {
  const key = e.key;
  const isCtrlOrCmd = e.ctrlKey || e.metaKey;

  if (isCtrlOrCmd && ["c", "v", "x", "a"].includes(key.toLowerCase())) {
    return;
  }

  const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
  const input = e.currentTarget;
  const currentValue = input.value;
  const selectionStart = input.selectionStart ?? 0;
  const selectionEnd = input.selectionEnd ?? 0;
  const nextValue = currentValue.slice(0, selectionStart) + key + currentValue.slice(selectionEnd);

  const isNumberKey = /^[0-9]$/.test(key);
  const isDot = key === ".";

  if (key === "0" && selectionStart === 0 && currentValue.length === 0) {
    e.preventDefault();
    return;
  }

  if (isDot) {
    if (currentValue.includes(".")) {
      e.preventDefault();
      return;
    }
    return;
  }

  if (isNumberKey && currentValue.includes(".")) {
    const decimalPart = nextValue.split(".")[1] ?? "";
    if (decimalPart.length > 2) {
      e.preventDefault();
      return;
    }
  }

  if (!isNumberKey && !isDot && !allowedKeys.includes(key)) {
    e.preventDefault();
  }
};

export function onInputNumberKeyPress(event: any, options?: { onlyInt: boolean }): void {
  if (options?.onlyInt && event.key === ".") {
    event.preventDefault();
  } else if (options?.onlyInt && event.key === "0" && event.target.selectionStart === 0) {
    event.preventDefault();
  } else if (event.key === "." && event.target?.value.split(".").length > 1) {
    event.preventDefault();
  }
  if (
    !/[0-9]/.test(event.key) &&
    ![".", "Backspace", "ArrowLeft", "ArrowRight", "Meta", "Tab"].includes(event.key) &&
    !event.ctrlKey
  ) {
    event.preventDefault();
  }
  const origString = event.target.value;
  const indexPosition = event.target.selectionStart;
  const stringToAdd = event.key;
  const newString =
    origString.slice(0, indexPosition) + stringToAdd + origString.slice(indexPosition);

  if (origString.includes(".") && /[0-9]/.test(event.key)) {
    const decimalPart = origString.split(".")[1] || "";
    const selectionStart = event.target.selectionStart || 0;
    const decimalPosition = origString.indexOf(".");
    if (selectionStart > decimalPosition && decimalPart.length >= 2) {
      event.preventDefault();
      return;
    }
  }

  if (
    event.key === "0" &&
    indexPosition !== origString.length &&
    `${parseFloat(newString)}` !== newString
  ) {
    event.preventDefault();
  }
}
export const NumberNotZero = (
  event: React.KeyboardEvent<HTMLInputElement>,
  allowDecimal = false,
) => {
  const char = event.key;
  const value = event.currentTarget.value;
  const selectionStart = event.currentTarget.selectionStart ?? 0;
  const selectionEnd = event.currentTarget.selectionEnd ?? 0;

  if (["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(char)) {
    return;
  }

  const newValue = value.slice(0, selectionStart) + char + value.slice(selectionEnd);

  if (allowDecimal) {
    if (!isValidDecimal(newValue)) {
      event.preventDefault();
    }
  } else {
    if (!isValidWholeNumber(newValue)) {
      event.preventDefault();
    }
  }
};

const isValidWholeNumber = (value: string) => {
  return /^\d*$/.test(value) && !/^0\d/.test(value);
};

const isValidDecimal = (value: string) => {
  const decimalPart = value.split(".")[1];
  return (
    /^\d*\.?\d*$/.test(value) && !/^0\d/.test(value) && (!decimalPart || decimalPart.length <= 2)
  );
};
